import Uiconstants from '../../lib/UIconstants';
import BonusWidgetController from '../../controllers/bonus/BonusWidgetController';
import { COMPONENTS } from '../../lib/constants';
import { isDesktop } from 'react-device-detect';

var pos = isDesktop ? { x: 234, y: -15 } : { x: 234, y: -15 };
var mult = isDesktop ? 1 : 2;

export const BonusBuyWidget = {
	name: COMPONENTS.BONUS_BUY_WIDGET,
	position: {
		x: 1410,
		y: 487
	},
	controllers: [
		{
			Controller: BonusWidgetController,
			name: Uiconstants.FTR_BONUS_BY,
			config: {
				item: COMPONENTS.BONUS_BUY_PAGE,
				modal: Uiconstants.FTR_BONUS_BY
				// border: "bg",
			}
		}
	],
	components: [
		{
			name: 'holder',
			type: 'Sprite',
			position: { x: 0, y: 0 },
			components: [
				{
					name: Uiconstants.FTR_BONUS_BY,
					type: 'Button',
					components: [
						{
							name: 'bg',
							type: 'MouseOverSprite',
							img: 'bonus_buy_widget_bg',
							imgHover: 'bonus_buy_widget_bg_hovered',
							// config: {
							//   hover: ["bg_border_top", "bg_border_bot"],
							//   default: ["bg_border_top_passive", "bg_border_bot_passive"],
							// },
							components: [
								{
									name: 'border',
									type: 'Sprite',
									img: 'bonus_border',
									position: { x: -23, y: -25 }
								}
							]
						}
					]
				},
				{
					name: 'fg',
					type: 'AnimatedSprite',
					position: pos,
					animation: {
						pattern: 'bookidle_000$.png',
						start: 0,
						end: 37,
						speed: 0.5,
						// scale: scaleScatter,
						loop: true,
						precision: 2,
						scale: {
							x: 1 * mult,
							y: 1 * mult
						}
					}
				},
				{
					name: 'BONUS_BUY_WIDGET_TITLE',
					type: 'Text',
					position: { x: 27, y: 30 },
					text: 'BONUS_BUY_WIDGET_TITLE'
				},
				{
					name: 'BONUS_BUY_VALUE',
					type: 'Text',
					position: { x: 27, y: 46 },
					text: 'BONUS_BUY_WIDGET_VALUE'
				}
			]
		}
	]
};
